"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.productionTimer = exports.nonProductionTimer = void 0;
var lodash_1 = require("lodash");
var environment_1 = __importDefault(require("./environment"));
var perf_1 = __importDefault(require("./perf"));
exports.nonProductionTimer = {
    start: function (name) {
        // eslint-disable-next-line no-console
        console.time("" + name);
        perf_1.default.mark(name + ":start");
    },
    stop: function (name) {
        perf_1.default.mark(name + ":end");
        perf_1.default.measure(name, name + ":start", name + ":end");
        // eslint-disable-next-line no-console
        console.timeEnd("" + name);
    },
};
exports.productionTimer = {
    start: lodash_1.noop,
    stop: lodash_1.noop,
};
exports.default = environment_1.default({
    production: exports.productionTimer,
    nonProduction: exports.nonProductionTimer,
});
